<template>
  <component :is="component"></component>
</template>
<script>
import Func16Listagem from '@/views/16/Func16Listagem.vue'

export default {
  name: 'Func16',
  data () {
    return {
      component: Func16Listagem
    }
  }
}
</script>
